import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the OrderbyKeywordPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'orderbyKeyword',
})
export class OrderbyKeywordPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(items: any[], filter: string): any {
    if (!items || !filter) {
        return items;
    } else {
      if(filter == 'asc'){
        //return items.sort((a, b) => (a.KeywordName > b.KeywordName) ? 1 : ((b.KeywordName > a.KeywordName) ? -1 : 0));
        return items.sort((a, b) => (a.KeywordName).localeCompare(b.KeywordName))
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/pipes/orderby-keyword/orderby-keyword.ts